import { atom } from 'jotai';

export const modeSwitcherAtom = atom('personal');
